module.exports = __webpack_public_path__ + "img/other-yellow.802fb17f.png";